import type {GuideComponents} from "@khan/guide-core";

export default function createFormUpdates(
    configName: string,
    form: GuideComponents["CreateForm"]["output"]["form"],
): Blob {
    const requests: any[] = [];
    switch (configName) {
        case "teacher-tool-multiple-choice-quiz":
        case "teacher-tool-multiple-choice-quiz-v2":
            form.forEach((question, index) => {
                const request = {
                    createItem: {
                        item: {
                            title: question.question,
                            questionItem: {
                                question: {
                                    required: true,
                                    grading: {
                                        pointValue: 1,
                                        correctAnswers: {
                                            answers: [
                                                {
                                                    value: question.answer,
                                                },
                                            ],
                                        },
                                    },
                                    choiceQuestion: {
                                        type: "RADIO",
                                        options: question.options.map(
                                            (option) => ({
                                                value: option,
                                            }),
                                        ),
                                        shuffle: true,
                                    },
                                },
                            },
                        },
                        location: {
                            index: index,
                        },
                    },
                };
                requests.push(request);
            });
            break;
        case "teacher-tool-exit-ticket":
        case "teacher-tool-exit-ticket-v2":
        case "teacher-tool-questions-generator":
        case "teacher-tool-questions-generator-v2":
            form.forEach((question, index) => {
                const request = {
                    createItem: {
                        item: {
                            title: question.question,
                            questionItem: {
                                question: {
                                    required: true,
                                    textQuestion: {
                                        paragraph: true,
                                    },
                                },
                            },
                        },
                        location: {
                            index: index,
                        },
                    },
                };
                requests.push(request);
            });
            break;
        default:
            throw new Error(`Unknown form config name: ${configName}`);
    }

    const updates = {
        requests: [
            {
                updateSettings: {
                    settings: {
                        quizSettings: {
                            isQuiz: true,
                        },
                    },
                    updateMask: "quizSettings.isQuiz",
                },
            },
            // Delete the first default question
            {
                deleteItem: {
                    location: {
                        index: 0,
                    },
                },
            },
            ...requests,
        ],
    };

    return new Blob([JSON.stringify(updates)], {
        type: "application/vnd.google-apps.form",
    });
}
